import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { decryptValue } from '../data/encryption';
@Injectable()
export class AuditTrailService {
  token: string;

  constructor(private http: HttpClient, private router: Router) { }

  InsertAuditTrail(sampleId: number, description: string, approverId: number, comments: string, uname: string,) {

    const AuditValue = {
      SAMPLE_ID: sampleId,
      DESCRIPTION: description,
      APPROVED_BY: approverId,
      COMMENTS: comments,
      CREATED_BY: uname,
      CREATED_ON: new Date()
    };

    this.http.post<any>(decryptValue(localStorage.getItem('BaseURL')) + '/audit_trail_service/audit_trail', AuditValue)
      .subscribe((PostData) => {
      },
        err => {
        });
  }
}
